<template>
  <van-divider v-if="isShowEmpty" dashed :style="{ color: '#aaa', borderColor: '#ccc', padding: '0 16px' }">
   {{ emptyMessageText }}
  </van-divider>
  <van-list
    v-model:loading="productLoading"
    :finished="productFinished"
    :finished-text="productData.length ? '没有更多了' : ''"
    @load="getProductData"
    direction="down"
  >
    <template v-for="(item, index) in productData" :key="item.productId + index">
      <!-- <TyreCard :datas="item" @link="toDetail(item)" />
      <LoyaltyCard :data="item" @link="toDetail(item)" />
      <ShopCard :data="item" @link="toDetail(item)" /> -->
      <!-- <p>{{ getComponentName(item) }}</p> -->
      <component :is="getComponentName(item)" :data="item" :gsCode="gsCode" :customerCarId="customerCarId" @link="toDetail(item)" />
    </template>
  </van-list>
</template>

<script>
import { reactive, toRefs, onMounted, onUnmounted, computed, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showToast } from '@/util/couponCollection'
import LoyaltyCard from '@/components/shop/LoyaltyCard'
import ShopCard from '@/components/shop/shopCard'
import TyreCard from '@/components/shop/TyreCard'
import TirePackage from '@/components/shop/TirePackage'
import EWCard from '@/components/shop/EWCard'
// import TyreCard from '@/components/tyre/TyreCard'
import { getProductList } from '@/api/directSales'
import { Dialog } from 'vant'
import { setSession, getSession, backTop } from '@/util'
import _ from 'lodash'
import { useStore } from 'vuex'

export default {
  name: 'searchPage',
  components: {
    LoyaltyCard,
    ShopCard,
    TyreCard,
    TirePackage,
    EWCard
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    let route = useRoute()
    let router = useRouter()
    let store = useStore()
    let { from } = route.query
    let { param } = toRefs(props)
    let state = reactive({
      param,
      isFirst: true,
      from,
      hasSeach: false,
      productData: [], // 产品数据
      productLoading: false,
      productCanLoad: false,
      productFinished: true,
      productPageNo: 1,
      pageSize: 10000,
      gsCode: '',
      customerCarId: ''
    })
    const getComponentName = data => {
      // Tire: 轮胎 SCProduct:服务合约产品 Loyalty:致友计划
      let vueList = {
        TirePackage: 'TirePackage',
        Tire: 'TyreCard',
        SCProduct: 'ShopCard',
        Loyalty: 'LoyaltyCard',
        EWProduct: EWCard
      }
      return data.productType && vueList[data.productType]
    }
    watch(
      () => state.param,
      _.debounce(v => {
        // console.log('shopList---watch', v)
        if (state.isFirst) {
          state.isFirst = false
          // 搜索数据保持
          // let param = getSession('shopListParam') || {}
          // let { carInfo = {} } = param
          // if (v?.carInfo?.id && carInfo?.id && v?.carInfo?.id === carInfo?.id) {
          //   getProductDataBySession()
          //   return
          // }
        }
        // console.log('shopList---watch--backTop')
        backTop()
        resetState()
        nextTick(() => {
          getProductData(true)
        })
      }, 500)
    )

    const getParams = () => {
      let { carInfo = {}, menuRes = {}, menuPopUpRes = [], dealer = {}, conditionRes = {} } = state.param
      let categoryCodes = menuPopUpRes.length ? menuPopUpRes : [menuRes?.identifier]
      categoryCodes = categoryCodes.filter(item => item)
      let gsCode = dealer?.gsCode || ''
      let customerCarId = carInfo?.id || ''
      let sortName = conditionRes?.id || ''
      let sortType = conditionRes?.direction || ''
      const fin = carInfo?.fin || ''
      const threeGuaranteesDate = carInfo?.threeGuaranteesDate || ''
      state.customerCarId = customerCarId
      state.gsCode = gsCode

      return {
        categoryCodes: categoryCodes.length ? categoryCodes : ['all'],
        gsCode,
        customerCarId,
        sortName,
        sortType,
        pageNo: state.productPageNo,
        pageSize: state.pageSize,
        fin,
        threeGuaranteesDate
      }
    }

    // 获取产品数据
    const getProductData = async (isInit = false) => {
      // if (!state.searchValue || !state.searchValue.trim()) {
      //   state.searchValue = ''
      //   state.productLoading = false
      //   state.hasSeach = false
      //   return
      // }
      // 防止反复加载，不要删
      if (!state.productCanLoad) return
      let params = getParams()
      state.productCanLoad = false
      try {
        // console.log("getProductData---------------", pramas);
        state.productLoading = true
        let list = await getProductList(params)
        const res = list ? list.map(item => ({ ...item, has_commodity: true })) : []
        state.productData = res
        !state.hasSeach && (state.hasSeach = true)
        state.productFinished = true
        state.productLoading = false
        state.productCanLoad = true
      } catch (e) {
        showToast(e.message, '请求产品列表数据失败')
        state.productLoading = false
        state.productCanLoad = false
        state.productFinished = true
      }
    }
    const getProductDataBySession = () => {
      let data = getSession('shopListDats')
      if (data) {
        state.productData = data.productData || []
        state.productPageNo = data.productPageNo || 1
        state.productFinished = data.productFinished || false
      }
      state.productCanLoad = true
      state.productLoading = false
    }

    // 重置state参数
    const resetState = async () => {
      // console.log("resetState---------------");
      state.productData = []
      state.productPageNo = 1
      state.hasSeach = false
      state.productLoading = false
      state.productCanLoad = true
      state.productFinished = false
    }

    // 跳转到详情
    const toDetail = item => {
      // Dialog({ title: '请先添加车辆', message: '请先添加爱车后才能查看商品详情', messageAlign: 'center' })
      // return
      if (item.productType === 'Loyalty') {
        store.dispatch('setLoyalty', item)
        router.push({ path: '/planDetail', query: { loyaltyId: item.productId, from: 'shopList', event: '查看致友计划详情' } })
        return false
      }
      if (item.productType === 'TirePackage') {
        // store.dispatch('setLoyalty', item)
        router.push({ path: '/planDetail', query: { loyaltyId: item.productId, from: 'TirePackage', event: '查看轮胎包计划详情' } })
        return false
      }
      if (item.productType === 'Tire') {
        // router.push({ path: '/tyreDetail', query: { tyreId: item.productId, event: '查看轮胎详情', from: 'shopList' } })
        // store.commit('SETCURRENTTYRE', item)
        // console.log('state.param', state.param)
        let tyreModel = state.param?.carInfo?.model?.replace(/\(.*?\)/g, '') || ''
        tyreModel && setSession('tyreModel', tyreModel)
        setSession('tyresList', '')
        setSession('modelList', '')
        router.push({ path: '/tyreList', query: { from: 'shopList', event: '轮胎列表' } })
        return false
      }
      if (['SCProduct', 'EWProduct'].includes(item.productType)) {
        let carId = state.param?.carInfo?.id || ''
        let fin = state.param?.carInfo?.fin || ''
        // let threeGuaranteesDate = state.param?.carInfo?.threeGuaranteesDate || ''
        if (!carId) {
          Dialog({ title: '请先添加车辆', message: '请先添加爱车后才能查看商品详情' })
          return
        }
        if (!fin) {
          Dialog({ title: '车辆信息缺失', message: '请先完善车辆FIN码后才能查看商品详情' })
          return
        }
        // if (!threeGuaranteesDate) {
        //   Dialog({ title: '车辆信息缺失', message: '请先完善车辆三包日期后才能查看商品详情' })
        //   return
        // }
        const navigationParams = {
          path: item.productType === 'EWProduct' ? '/ewShopDetail' : '/shopDetail',
          query: {
            spuId: item.productId,
            event: item.productType === 'EWProduct' ? '查看延保商品详情' : '查看商品详情',
            from: 'shopList'
          }
        }

        router.push(navigationParams)
        store.commit('SETCURRENTSHOP', item)
        return false
      }
      showToast('产品数据有误, 请联系系统管理员\n' + item.productType)
      console.error('toDetail--item.productType', item.productType, item)
    }
    const isShowEmpty = computed(() => {
      return !state.productData.length && !state.productLoading && state.hasSeach
    })

    // 是否绑车
    const isBindCar = computed(() => {
      return store.state.isBindCar
    })

    // 是否是 轮胎套餐
    const isTirePackage = computed(() => {
      let { menuRes = {}, menuPopUpRes = [] } = state.param
      let categoryCodes = menuPopUpRes.length ? menuPopUpRes : [menuRes?.identifier]
      return categoryCodes.includes('TirePackage')
    })

    // 获取 没有数据时 展示文本
    const emptyMessageText = computed(() => {
      if (isTirePackage.value && !isBindCar.value) {
        return '绑定车辆后即可查看可购买产品'
      }
      return '暂无可购买产品，请联系经销商'
    })

    onMounted(async () => {
      store.commit('SETBRANDINFO', null)
      // 获取绑定车辆的状态
      await store.dispatch('getBindCarStatus')
      let from = route.query.from
      // getProductData()
      // let searchData = getSession('searchData')
      // if (!searchData) {
      //   resetState()
      // } else {
      //   state = Object.assign(state, searchData, { from })
      //   if (searchData.from !== from) {
      //       // getLoyaltyData(true)
      //   }
      // }
    })
    onUnmounted(() => {
      setSession('shopListParam', state.param)
      setSession('shopListDats', { productData: state.productData, productPageNo: state.productPageNo, productFinished: state.productFinished })
    })

    return {
      ...toRefs(state),
      isShowEmpty,
      isBindCar,
      isTirePackage,
      emptyMessageText,
      getProductData,
      toDetail,
      getComponentName
    }
  }
}
</script>

<style lang="scss" scoped>
.tyreCard,
.loyaltyCard,
.shopCard {
  margin-bottom: 12px;
  background: #fff;
}
</style>
